// Visibility of components sent from API
const Visibility = Object.freeze({
  ENABLED: 1,
  REQUIRED: 2,
});

export default Visibility;
